import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { DocumentationDto } from '../../models/documentations/documentation-dto';

@Injectable()
export class DocumentationService extends Service {


    public documentations: DocumentationDto[];
    public documentationsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.documentations = [];
        this.documentationsObject = {};
    }

    public getAll(): Observable<DocumentationDto[]> {
        if (!!this.documentations && this.documentations.length > 0) {
            return Observable.create((observer: Subscriber<DocumentationDto[]>) => {
                observer.next(this.documentations);
                observer.complete();
            });
        }
        const url = 'documentations/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.documentations = r.Result;
                this.documentationsObject = this.documentations.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            console.log('this.documentations', this.documentations);
            return this.documentations;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/documentations/documentation.service.ts